import './Step.scss'
import {LuxIcon} from '@lux/wardrobe-lib'

const Step = (props) => {
    const componentClass = 'smart-modals-new-activity-step'

    return (
        <div className={componentClass}>
            {props.icon && <LuxIcon icon={props.icon} color={props.color}/>}
            {!props.icon && <div className={`${componentClass}__empty-icon`}/>}
            <label className='semi-bold'>{props.step}</label>
        </div>
    )
}

export default Step
